import React from "react";
import { PARTS, SECTIONS } from "@/data/workbook";
import { sectionProgress } from "@/lib/progress";
import { Check } from "lucide-react";

export default function SectionNav({ data, photoCount, activeId, onSelect }) {
  return (
    <nav className="space-y-6">
      {PARTS.map((part) => {
        const sections = SECTIONS.filter((s) => s.part === part.id);
        return (
          <div key={part.id}>
            <div className="mb-2 flex items-center gap-2 px-2">
              <span className="flex h-6 w-6 items-center justify-center rounded-md font-mono text-xs font-bold" style={{ background: part.color, color: "#0B0F17" }}>{part.id}</span>
              <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{part.title}</span>
            </div>
            <div className="space-y-0.5">
              {sections.map((s) => {
                const pct = sectionProgress(s, data, photoCount);
                const active = s.id === activeId;
                return (
                  <button
                    key={s.id}
                    data-testid={`nav-section-${s.id}`}
                    onClick={() => onSelect(s.id)}
                    className={`flex w-full items-center gap-2.5 rounded-lg px-2.5 py-2 text-left tap-scale ${
                      active ? "bg-primary/15 ring-1 ring-primary/40" : "hover:bg-secondary/60"
                    }`}
                  >
                    <span className={`flex h-6 w-9 shrink-0 items-center justify-center rounded font-mono text-[11px] font-bold ${active ? "text-primary" : "text-muted-foreground"}`}>{s.num}</span>
                    <span className={`flex-1 truncate text-[13px] leading-tight ${active ? "text-foreground" : "text-foreground/80"}`}>{s.title}</span>
                    {pct === 100 ? (
                      <Check className="h-4 w-4 shrink-0 text-emerald-500" />
                    ) : pct > 0 ? (
                      <span className="shrink-0 font-mono text-[10px] text-primary">{pct}%</span>
                    ) : null}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </nav>
  );
}
